import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useDocumentTitle } from '@/lib/useDocumentTitle';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  /** The primary action, shown on the right. */
  action?: ReactNode;
}

/** The title block every list page in the wireframes begins with. */
export function PageHeader({ title, description, action }: PageHeaderProps) {
  useDocumentTitle(title);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
        mb: 3,
      }}
    >
      <Box>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {description ? (
          <Typography color="text.secondary" sx={{ mt: 0.5 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      {action}
    </Box>
  );
}
